// extracted by mini-css-extract-plugin
export default {"value":"HomeCard_value__xIfra","subtitle":"HomeCard_subtitle__g1hL3","card":"HomeCard_card__4GOG5"};